import React from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/Box';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import AvailableResourcesSectionPicker from './AvailableResourcesSectionPicker';

const useStyles = buildUseStyles('AvailableResources', (() => ({
  root: {
    overflowX: 'hidden',
  },
})));

const AvailableResources = ({ relationship }) => {
  const classes = useStyles();
  return (
    <Box padding={2} className={classes.root}>
      <AvailableResourcesSectionPicker relationship={relationship} />
    </Box>
  );
};


AvailableResources.propTypes = {
  relationship: PropTypes.object.isRequired,
};

export default AvailableResources;
